import "core-js/modules/es.object.keys.js";
import env from '@tencent/vft-common/env';
import KVParser from '@tencent/vft-common/KVParser';
export function isFunction(fn) {
  return typeof fn === 'function';
}
/**
 * 格式化数据
 * @param {String|Object} data 参数
 * @param {Boolean} reportBoss 是否上报鹰眼
 */

var kvParser = new KVParser({
  skipEmpty: true
});
export function query2obj(data) {
  var result = {};

  if (typeof data === 'string') {
    result = kvParser.parse(data);
  }

  return result;
}
/**
 * 获取上报类型
 * @param {VftReport.DirectiveModifiers} modifiers 指令修饰符
 *
 * @return {VftReport.ReportType}
 */

export function getReportType(modifiers) {
  return Object.keys(modifiers)[0] || 'all';
}
/**
 * 获取平台号
 */

export function getPlatform() {
  var platform = {
    kidapp: {
      iphone: 8004,
      aphone: 8003,
      ipad: 8005,
      apad: 8006
    },
    app: {
      iphone: 7,
      aphone: 8,
      ipad: 5,
      apad: 6,
      windows: 2000,
      mac: 2001
    },
    web: 1000,
    h5: 3000
  };
  var plat = platform[env.app] || platform.app;

  if (env.isApp && plat[env.device]) {
    return plat[env.device];
  }

  return env.isWeb ? platform.web : platform.h5;
}